import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

type UseDeleteAnnualReviewArgs = { onSuccess?: () => void }

export const useDeleteAnnualReviewConfirmation = ({ onSuccess }: UseDeleteAnnualReviewArgs) => {
  const router = useRouter()

  const [arForDelete, setArForDelete] = useState<number | null>(null)

  const { mutate: deleteAnnualReview } = useMutation<void, Error, { id: number }>({
    mutationFn: ({ id }) => Request.delete(Request.urls.bank.annualReview, { id }),
    onSuccess: async () => {
      Toast.successSmall(`Annual Review was successfully deleted.`)

      if (onSuccess) onSuccess()
      else router.invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  const { Confirmation, open } = useConfirmation({
    message: <>Are you sure you want to delete "AR-{arForDelete}" Annual Review?</>,
    onConfirm: () => {
      if (arForDelete) deleteAnnualReview({ id: arForDelete })
    },
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true,
    onCancel: () => setArForDelete(null)
  })

  const openDeleteAnnualReviewConfirmation = (id: number) => {
    setArForDelete(id)
    open()
  }

  return { DeleteConfirmation: Confirmation, openDeleteAnnualReviewConfirmation }
}
